import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Footer from "../components/Footer";
import NewNav from "../components/NewNav";
import "aos/dist/aos.css";
import video1 from "../images/video1.mp4";
import video2 from "../images/video2.mp4";
import video3 from "../images/video3.mp4";
import video4 from "../images/video4.mp4";
import video5 from "../images/video5.mp4";
import video6 from "../images/video6.mp4";
import video7 from "../images/video7.mp4";
import about from "../images/product6.jpg";




const videos = [
 
  {
     src: video2,
 
  },
  {
     src: video3,
  },
  {
     src: video5,
  
  },
 
];

const content = {
  aboutUs:
    "WELCOME TO ORION LIGHTING, WHERE INNOVATION MEETS ILLUMINATION. ESTABLISHED IN 2017, WE ARE PREMIER MANUFACTURERS OF HIGH QUALITY LIGHTING SOLUTIONS DESIGNED TO ENHANCE YOUR SPACE AND BRING YOUR VISION TO LIFE.",
  mission:
    "AT ORION LIGHTING, OUR MISSION IS SIMPLE. TO LIGHT UP YOUR WORLD WITH EXCELLENCE, WE ARE DEDICATED TO PROVIDING TOP NOTCH LIGHTING PRODUCTS THAT BLEND FUNCTIONALITY, STYLE AND ENERGY EFFICIENCY. WHETHER YOU ARE LOOKING TO BRIGHTEN UP YOUR HOME, OFFICE OR COMMERCIAL SPACE, OUR DIVERSE RANGE OF LIGHTING SOLUTIONS ARE CRAFTED TO MEET YOUR UNIQUE NEEDS AND PREFERENCES.",
  whyChooseUs: [
    {
      title: "Expertise and Innovation",
      description:
        "ORION LIGHTING HAS DEVELOPED HIGH-END PRODUCTS TO PROVIDE ITS CONSUMERS WITH PREMIUM QUALITY PRODUCTS. OUR PRODUCTION CAPACITY IS 1 MILLION PIECES A MONTH WITH HIGH TECH SEMI-AUTO AND FULLY AUTO ASSEMBLY LINES.",
    },
    {
      title: "Quality Craftsmanship",
      description:
        "WE IMPLEMENT WORLD-CLASS QUALITY STANDARDS, INCLUDING ISO 9001, ISO 2015, AND VDA 6.2 CERTIFICATIONS. OUR QUALITY CONTROL LAB TESTS EACH PRODUCT USING HIGH-END EQUIPMENT TO ENSURE ONLY QC-APPROVED PRODUCTS ARE DELIVERED.",
    },
    {
      title: "Customer-Centric Approach",
      description:
        "YOUR SATISFACTION IS OUR TOP PRIORITY. FROM THE MOMENT YOU REACH OUT TO US, WE PROVIDE PERSONALIZED SUPPORT, EXPERT ADVICE, AND SEAMLESS SERVICE.",
    },
  ],
  closingStatement:
    "ORION LIGHTING ENVISIONS A WORLD WHERE LIGHTING TRANSFORMS SPACES AND ELEVATES EXPERIENCES BY PUSHING DESIGN AND TECHNOLOGY. WE AIM TO INSPIRE AND ILLUMINATE EVERY PROJECT, MAKING ORDINARY SPACES EXTRAORDINARY.",
  contactInfo:
    "TO BE A PART OF THE ORION FAMILY, PLEASE REACH OUT AT info@orionlightingpvtltd.com OR CALL US ON 042-37510711.",
};

function About() {
  return (
    <>
      <NewNav />

      <section className="about-section py-5 bg-light mt-5">
        <Container>
          <Row className="align-items-center mb-5">
            <Col md={6}>
              <h2 className="mb-4 text-black">About Orion Lighting</h2>
              <p className="lead">{content.aboutUs}</p>
              <p>{content.mission}</p>
            </Col>
            <Col md={6}>
              <img
          src={about}               
           alt="Orion Lighting"
                className="img-fluid rounded shadow"
              />
            </Col>
          </Row>

          <h3 className="text-center mb-4">Why Choose Us?</h3>
          <Row className="mb-5">
            {content.whyChooseUs.map(({ title, description }, idx) => (
              <Col key={idx} md={4} className="mb-4">
                <Card className="h-100 shadow-sm border-0">
                  <Card.Body>
                    <Card.Title className="text-black">{title}</Card.Title>
                    <Card.Text>{description}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          <h3 className="text-center mb-4">Our Videos</h3>
          <Row>
            {videos.map(({ src, title }, idx) => (
              <Col key={idx} md={6} lg={4} className="mb-4">
                <Card className="h-100 shadow-sm border-0">
                  <div className="ratio ratio-16x9 rounded-top overflow-hidden">
                    <iframe
                      src={`${src}?controls=0&mute=1&modestbranding=1&rel=0&showinfo=0&iv_load_policy=3&fs=0&disablekb=1`}
                      title={title}
                      allow="autoplay"
                      allowFullScreen
                      frameBorder="0"
                      className="w-100 h-100"
                    ></iframe>
                  </div>
                </Card>
              </Col>
            ))}


          </Row>

          <section className="my-5">
            <h3 className="text-center mb-3">Our Mission & Vision</h3>
            <p className="text-center fst-italic">{content.closingStatement}</p>
          </section>

          <section className="text-center py-4 bg-black text-white rounded">
            <p className="mb-0">{content.contactInfo}</p>
          </section>
        </Container>
      </section>

      <Footer />
    </>
  );
}

export default About;
